// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page[data-v-17e46b0f]{display:flex;flex-flow:column;min-height:100vh}.page .app-container-wrapper[data-v-17e46b0f]{display:flex;flex-flow:column;flex-grow:2}.page .app-container-wrapper .app-container[data-v-17e46b0f]{flex-grow:2}\n", ""]);
// Exports
module.exports = exports;
